import React, { Component } from 'react'

export default class Single extends Component {
    constructor(props) {
        super(props)

        this.state = {
           
        }
    }

    render() {
        // const currentTime = Math.floor(Date.now() / 1000); // Current time in Unix timestamp
        // const expirationDate = this.props.question.expiration_date;

        // if (expirationDate !== 0 && expirationDate < currentTime) {
        //     return null;
        // }
        return (
            <div className="faq_question__container p-3 mb-4">
                <div className="col-12 faq_question__title">
                    <a href={"/questions/" + this.props.question.url}
                        onClick="dataLayer.push({'event': 'myTrackEvent', 'eventCategory': 'FAQ', 'eventAction': 'Click Other FAQ', 'eventLabel': '{title}'})">
                        <span className="mr-2">Q.</span>
                        <h3> {this.props.question.title}</h3>
                    </a>
                </div>

                <div className="col-12">
                    <div className="row">
                    <div className="col-3 col-sm-2 rs-article__author_image d-flex align-items-center justify-content-center px-0">
        
                        <img loading="lazy" src={this.props.question.author_pic} alt={"Author:" + this.props.question.author_name} title={"Author: "+ this.props.question.author_name}
                        />
                    </div>
                    < div className="col-9 col-sm-10 rs-article__author_details">
                        <div className="row">
                                <div className="col-12 faq_question__author">
                                    <h4>Answered by {this.props.question.author_name}</h4>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 rs-article__author_profession">
                                        <span>{this.props.question.author_intro}</span>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
                        <div className="col-12">
                            <p>
                                
                        {this.props.question.answer}
                                    < a href={"/questions/" + this.props.question.url}> read more</a>
                    </p>
                </div >
            </div >            
        )
    }

}

